import React from 'react'
import {useDrag} from 'react-dnd'
import BasicBadge, {BadgeStyle} from "@components/BasicBadge";
import {badgeStyle} from "@commons/components/BasicBadge";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";

interface DropResult {
    name: string
}

const Giustificativo4Drag: React.FC<{
    elemento: GiustificativoRecord,
    type: string,
    //setElementiSelezionabili: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    //setElementiSelezionati: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>
}> = ({elemento, type,}) => {

    const [{isDragging}, drag] = useDrag(() => ({
        type: type,
        item: elemento,
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult<DropResult>()
            if (item && dropResult) {
                //alert(`You dropped ${item.elemento.descrizione} into ${dropResult.name}!`)
                const elemento = item;//.elemento;
                let selezionato;
                /*if (type === ItemTypes.TURNO) {
                    console.log("abilito voce", item.descrizione);
                    selezionato = true;
                } else {
                    console.log("disabilito voce", item.descrizione);
                    selezionato = false;
                }*/
                /*updateTrigger({...item, selezionato})
                    .unwrap()
                    .then(() => {
                        setElementiSelezionabili((v) => v.filter(obj => obj.codElemento !== elemento.codElemento));
                        setElementiSelezionati((v) => v.concat([elemento]));
                    })
                    .catch((error: MutationError) => {
                        // @ts-ignore
                        const message = error.data.message;
                        toastAsError(message);
                    })*/
            }
        },

        collect: monitor => ({
            isDragging: !!monitor.isDragging(),
        }),
    }))

    let style: BadgeStyle | undefined = elemento.bgColor ? {bg: elemento.bgColor!, text: 'text-black'} : undefined;
    const opacity = isDragging ? 'opacity-50' : 'opacity-100';
    return (
        <div ref={drag} className="text-center cursor-move max-w-full">
            <BasicBadge as="div" label={elemento.descrizione!} type={"custom"}
                        containerClass={`text-sm ${opacity} min-w-[60px] text-ellipsis overflow-hidden whitespace-nowrap`}
                        customStyle={style || {bg: `${badgeStyle.primary.bg}`, text: "text‑current"}}></BasicBadge>
        </div>
    )
}

export default Giustificativo4Drag